import { Inject, Injectable } from '@angular/core'
import { GbCookieService } from 'libs/shared/utils/services/src'
import { CookieService } from 'ngx-cookie-service'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'

@Injectable({
  providedIn: 'root',
})
export class GbFrontCookieService extends GbCookieService {
  constructor(protected cookieService: CookieService, @Inject(APP_CONFIG) protected appConfig: any) {
    super(cookieService, appConfig)
  }

  isVolunteer(token?: string): boolean {
    const decodedToken = this.getDecodedTokenCookie(token)
    return decodedToken ? !!decodedToken.v : false
  }

  isGuest(token?: string): boolean {
    const decodedToken = this.getDecodedTokenCookie(token)
    return decodedToken ? !!decodedToken.p : false
  }

  /**
   * Returns if volunteer not part of the current auction
   */
  isInvalidVolunteer(auctionUuid: string): boolean {
    const decodedToken = this.getDecodedTokenCookie()
    return !!decodedToken?.v && decodedToken.a !== auctionUuid
  }
}
